/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_StartInputs */

const en_cook_start = /** @type {(inputs: Cook_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cook`)
};

const de_cook_start = /** @type {(inputs: Cook_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochen`)
};

/**
* | output |
* | --- |
* | "Cook" |
*
* @param {Cook_StartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_start = /** @type {((inputs?: Cook_StartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_StartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_start(inputs)
	return en_cook_start(inputs)
});